/**
 * Company: SPHMedia
 * Description: [Budget Banner]
 */

import BudgetDesktopIcon from "@assets/budget/desktop-other-pages.svg";
import BudgetMobileIcon from "@assets/budget/mobile-other-pages.svg";
import { BUGET_2026_PAGE } from "@config/budget";
import Link from "@elements/Typography/Link";
import { ReactElement } from "react";

/**
 * GEBanner
 * Description: [Budget Banner component]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function BudgetBanner(): ReactElement {
  const landingPagePath = `${BUGET_2026_PAGE}?ref=banner`;

  return (
    <div className="flex justify-center items-center bg-blue-400 py-2">
      <div className="gap-2 items-center hidden lg:flex">
        <img src={BudgetDesktopIcon} alt="ge-icon" width={89} height={30} />
        <Link
          destination={landingPagePath}
          className="text-md font-medium text-white-100 font-primary underline leading-[normal]"
        >
          Dapatkan berita terkini tentang belanjawan 2026 di sini
        </Link>
      </div>
      <div className="flex lg:hidden gap-3 items-center justify-start px-2.5">
        <img src={BudgetMobileIcon} alt="ge-icon" width={118} height={40} />
        <div className="flex flex-col gap-[2px]">
          <Link
            destination={landingPagePath}
            className="text-[14px] font-semimedium text-white-100 font-primary underline leading-[20px]"
          >
            Dapatkan berita terkini tentang
            <br />
            belanjawan 2026 di sini
          </Link>
        </div>
      </div>
    </div>
  );
}
